import { render, staticRenderFns } from "./LogoutComponent.vue?vue&type=template&id=e4c345e4"
import script from "./LogoutComponent.vue?vue&type=script&lang=js"
export * from "./LogoutComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports